/*
 * This file is generated by icons/template.js
 */
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { COMMON, CommonProps } from '../constants';
import theme from '../theme';
import sizeStyle, { IconSizeProps } from '../lib/iconSize';

const SvgComponent = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" viewBox="0 0 512 512" {...props}>
    <path
      d="M256 1c140.833 0 255 114.167 255 255S396.833 511 256 511 1 396.833 1 256 115.167 1 256 1zm10.987 130.532c-37.797-6.892-72.029 22.035-72.029 59.625v46.573c0 21.854 11.962 41.779 30.935 52.574 8.871 5.043 13.204 15.193 10.925 24.897-2.37 10.092-11.35 17.39-22.022 17.39h-29.851c-34.285 0-62.422 28.136-62.422 62.42l-.003 28.22c36.568 29.159 82.903 46.587 133.309 46.587 50.217 0 96.394-17.298 132.897-46.26l-.004-28.546c0-34.285-28.137-62.422-62.421-62.422h-29.852c-10.672 0-19.651-7.297-22.021-17.389-2.28-9.704 2.054-19.854 10.916-24.892 18.982-10.8 30.944-30.725 30.944-52.58v-41.635c0-31.695-21.065-59.412-49.3-64.562zM255.83 41.84c-118.183 0-213.99 95.806-213.99 213.989 0 46.418 14.78 89.384 39.89 124.449 6.453-45.198 42.114-81.243 87.123-88.278-10.062-15.928-15.73-34.618-15.73-54.27v-46.573c0-63.573 57.759-112.382 121.372-100.782 48.947 8.928 83.63 54.564 83.63 105.719v41.636c0 19.652-5.668 38.341-15.731 54.27 45.168 7.06 80.922 43.334 87.189 88.753 25.321-35.148 40.236-78.294 40.236-124.924 0-118.183-95.806-213.99-213.99-213.99z"
      fill="#363135"
      fillRule="evenodd"
    />
  </svg>
);

type Props = CommonProps & IconSizeProps;
const IconDefaultAvatar = styled(SvgComponent)<Props>`
  ${sizeStyle}
  ${COMMON}
`;
IconDefaultAvatar.defaultProps = {
  theme,
};
IconDefaultAvatar.propTypes = { ...sizeStyle.propTypes, ...COMMON.propTypes, theme: PropTypes.object };
IconDefaultAvatar.displayName = 'IconDefaultAvatar';
export { IconDefaultAvatar };
